import { render } from "./RepliSellerPortal.vue?vue&type=template&id=152e2373"
import script from "./RepliSellerPortal.vue?vue&type=script&lang=js"
export * from "./RepliSellerPortal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__